import {AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit, Output} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {BehaviorSubject, Subscription} from "rxjs";
import {GrupoCarteiraService} from "../../grupo-carteira.service";
import {ToastService} from "maps-angular-components";
import {HttpErrorResponse} from "@angular/common/http";
import {indicate} from "../../../shared/util/loading-indicate";

@Component({
  selector: "modal-deletar-grupo-carteira",
  templateUrl: "modal-deletar-grupo-carteira.component.html",
})
export class ModalDeletarGrupoCarteiraComponent
  implements AfterViewInit, OnDestroy, OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: string,
              private readonly service: GrupoCarteiraService,
              private readonly toastService: ToastService,
  ) {
    this.id = data;
  }

  @Output() grupoExcluido = new EventEmitter();
  private readonly subscriptions = new Subscription();

  loadingDelete$ = new BehaviorSubject(false);

  id: string;

  ngAfterViewInit(): void {
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  excluir() {
    this.service.excluirGrupoCarteira(this.id).pipe(indicate(this.loadingDelete$)).subscribe(
      () => {
        this.toastService.textoLight("Exclusão do grupo de carteira enviada para autorização!");
        this.grupoExcluido.emit()
      },
      (error: HttpErrorResponse) => {
        this.toastService.erro(error.error.message);
      }
    )
  }
}
